// extracted by mini-css-extract-plugin
export default {"contenedorImagenes":"ImagenesVender_contenedorImagenes__Ncivp","textoImagenes":"ImagenesVender_textoImagenes__pVznn","imagenes":"ImagenesVender_imagenes__uCvP9"};